// UI REDUCERS
export const LOADING_ON = "LOADING_ON";
export const LOADING_OFF = "LOADING_OFF";
export const SET_THEME = "SET_THEME";
export const SET_LANG = "SET_LANG";




// USER REDUCER
export const SET_NAME = "SET_NAME";
export const SET_NAME_NO_COUNTER = "SET_NAME_NO_COUNTER";
export const USER_ERROR = "USER_ERROR";